<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle
    [title]="vehicleId?('Showing Trips of \''+customerName+'\' with - '+vehicleName):('Showing Trips of '+customerName)"></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-start">
            <!--            <input-->
            <!--              ngxDaterangepickerMd-->
            <!--              [closeOnAutoApply]="true"-->
            <!--              [autoApply]="true"-->
            <!--              [singleDatePicker]="true"-->
            <!--              [linkedCalendars]="true"-->
            <!--              [(ngModel)]="selected"-->
            <!--              class="datepicker-calendar-icon">-->

            <!--            <a class="ngx-daterangepicker-action" (click)="openDatepicker()">-->
            <!--              Open-->
            <!--            </a>-->
            <div class="form-group pl-3">
              <input type="text" matInput
                     id="exampleInputEmail1"
                     ngxDaterangepickerMd
                     class="form-control pl-3"
                     [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD',clearLabel:'Clear'}"
                     startKey="start"
                     endKey="end"
                     placeholder="Filter by Date Range"
                     [(ngModel)]="selected"
                     [showClearButton]="true"
                     (ngModelChange)="onDateRangeModelChange($event)"
                     (datesUpdated)="onDatesChanged($event)"
                     #dateRangePicker/>

            </div>
            <!--            <mat-form-field appearance="fill" class="pb-0 pl-3" (click)="openDateRangePicker()">-->
            <!--              <mat-label>Filter by Date Range</mat-label>-->
            <!--              <input type="text" matInput-->
            <!--                     ngxDaterangepickerMd-->
            <!--                     [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD',clearLabel:'Clear'}"-->
            <!--                     startKey="start"-->
            <!--                     endKey="end"-->
            <!--                     [(ngModel)]="selected"-->
            <!--                     [showClearButton]="true"-->
            <!--                     (ngModelChange)="onDateRangeModelChange()"-->
            <!--                     (datesUpdated)="onDatesChanged($event)"-->
            <!--                     #dateRangePicker/>-->
            <!--            </mat-form-field>-->
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Start Location</th>
                <th>Destination</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Trip Details</th>
                <th>Driving Alerts</th>
                <th *ngIf="userType=='fleet'">Status</th>
                <th>Vehicle</th>
                <th *ngIf="userType=='fleet'">Map</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of userTrips; let i= index">
                <td>{{i + 1}}</td>
                <td>{{processLocationName(item.startLocationName)}}</td>
                <td>{{processLocationName(item.destinationName)}}</td>
                <td>{{item.startTime}}</td>
                <td>{{item.endTime}}</td>
                <td>
                  <strong>Top Speed </strong><span *ngIf="item.topSpeed">{{item.topSpeed}}</span><span
                  *ngIf="!item.topSpeed">-</span><br>
                  <strong>Max RPM </strong><span *ngIf="item.maxRmp">{{item.maxRmp}}</span><span
                  *ngIf="!item.maxRmp">-</span><br>
                  <strong>Mileage </strong><span *ngIf="item.mileage">{{item.mileage}}Km</span><span
                  *ngIf="!item.mileage">-</span><br>
                  <strong>Distance </strong>{{item.tripDistance}}Km<br>
                  <strong>Duration </strong>{{getDuration(item.tripDuration)}}
                </td>
                <td>{{item.drivingAlertsCount}}</td>
                <td *ngIf="userType=='fleet'">
                  <div *ngIf="!item.endTime" class="green-dot" matTooltip="Trip is not yet Ended"></div>
                  <div *ngIf="item.endTime" class="solid-blue-dot" matTooltip="Trip is Ended"></div>
                </td>
                <td>{{item.tripVehicle.vehicleBrand + '-' + item.tripVehicle.vehicleModel + '-' + item.tripVehicle.regNumber}}</td>
                <td *ngIf="userType=='fleet'"><a href="javascript:void(0)" [routerLink]="['map',item.userTripId]">Map
                  View</a></td>
                <td><a href="javascript:void(0)" [routerLink]="['../../','driving-alerts']"
                       [queryParams]="{name:customerName+' Trip',tripId:item.userTripId}">Driving Alerts</a></td>
              </tr>
              </tbody>
            </table>
            <mat-paginator (page)="pageEvent = getServerData($event)" [length]="totalRecords"
                           [pageSize]="search.size"
                           [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
